module.exports = __webpack_public_path__ + "img/computer-classic.dc53564d.svg";